export default __webpack_public_path__ + "static/media/ruby.54b6437b.png";